export const emailRegex: RegExp =
  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const phoneRegex: RegExp = /^\+?\d{10,15}$/;